import angular from 'angular';

import { taskLink } from './directives/task.link.directive';
import { tasksDaily } from './tasks.daily/tasks.daily.directive';
import { TasksOverview } from './tasks.overview.resource';
import { routesConfig } from './tasks.overview.routes';
import { tasksToday } from './tasks.today/tasks.today.directive';

export default angular
  .module('tasks.overview', ['ngResource'])
  .factory('TasksOverview', TasksOverview)
  .directive('taskLink', taskLink)
  .directive('tasksDaily', tasksDaily)
  .directive('tasksToday', tasksToday)
  .config(routesConfig);
